import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const ApiSolutions = () => {
  // API data
  const apis = [
    {
      id: 1,
      title: "Recharge API",
      description:
        "Instant prepaid, postpaid, DTH, data card and google play recharge for all major operators.",
      features: [
        "98%+ success rate",
        "Real-time transaction status",
        "Zero Complaints",
        "Low latency",
      ],
      icon: "📱",
      color: "#4f46e5",
      docLink: "#",
    },
    {
      id: 2,
      title: "BBPS API",
      description:
        "Bharat Bill Payment System integration for electricity, water, gas, broadband, and more.",
      features: [
        "Access to 1500+ billers",
        "Instant bill fetch & payment",
        "Secure & compliant",
        "Detailed reports",
      ],
      icon: "💡",
      color: "#10b981",
      docLink: "#",
    },
    {
      id: 3,
      title: "Offline PAN Card API",
      description:
        "Enable Offline PAN card creation, real-time coupon distribution, and seamless PAN card application through APIs.",
      features: [
        "Direct Offline PAN Card Creation",
        "PAN Coupon Distribution",
        "Real-time API Responsess",
        "24x7 Customer Support",
      ],
      icon: "🪪",
      color: "#f59e0b",
      docLink: "#",
    },
    {
      id: 4,
      title: "NSDL PAN Card API",
      description:
        "Paperless PAN application with Aadhaar eKYC and eSign based with instant acknowledgements.",
      features: [
        "Direct NSDL integration",
        "Aadhaar eKYC based PAN application",
        "100% Paperless process",
        "24x7 service availability",
      ],
      icon: "🪪",
      color: "#ef4444",
      docLink: "#",
    },
    {
      id: 5,
      title: "Insurance POSP API",
      description:
        "Motor insurance (two-wheeler & four-wheeler) quote and issuance from top insurers.",
      features: [
        "Compare 10+ insurers",
        "Instant policy issuance",
        "Instant Commission credited",
        "POSP-compliant",
      ],
      icon: "🚗",
      color: "#8b5cf6",
      docLink: "#",
    },
  ];

  return (
    <React.Fragment>
      <Header variant="light" />
      <div className="api-solutions-page">
        <Helmet>
          <title>API Solutions - Panmitra Online Services</title>
          <meta
            name="description"
            content="Explore Panmitra's powerful APIs for recharge, BBPS, PAN card (UTI/NSDL), and motor insurance. Easy integration, production ready environment, and 24/7 developer support."
          />
        </Helmet>

        <div className="body-overlay"></div>

        <main>
          {/*===== HERO AREA STARTS =======*/}
          <div
            className="about-header-area"
            style={{
              backgroundImage: "url(assets/img/bg/inner-header.png)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-7 m-auto">
                  <div className="about-inner-header heading9 text-center">
                    <h1>API Solutions</h1>
                    <a href="/">
                      Home <i className="fa-solid fa-angle-right" />{" "}
                      <span>API Solutions</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*===== API INTRO SECTION =====*/}
          <section className="api-intro sp1">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="heading2">
                    <h5>Integrate with ease</h5>
                    <h2>Powerful APIs to scale your business</h2>
                    <p className="intro-text">
                      Panmitra offers robust, developer-friendly REST APIs that
                      let you integrate PAN card services, recharges, bill
                      payments, and insurance directly into your own
                      applications. With detailed documentation, production
                      ready environment, and 24/7 support, you can go live in
                      days, not weeks.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/*===== API CARDS GRID =====*/}
          <section className="api-grid">
            <div className="container">
              <div className="row g-4">
                {apis.map((api) => (
                  <div key={api.id} className="col-lg-4 col-md-6">
                    <div
                      className="api-card"
                      style={{ borderTopColor: api.color }}
                    >
                      <div className="card-header">
                        <span
                          className="api-icon"
                          style={{
                            backgroundColor: api.color + "20",
                            color: api.color,
                          }}
                        >
                          {api.icon}
                        </span>
                        <h3>{api.title}</h3>
                      </div>
                      <p className="api-description">{api.description}</p>
                      <ul className="api-features">
                        {api.features.map((feature, idx) => (
                          <li key={idx}>
                            <i
                              className="fa-solid fa-check-circle"
                              style={{ color: api.color }}
                            ></i>{" "}
                            {feature}
                          </li>
                        ))}
                      </ul>
                      <div className="card-footer">
                        <a
                          href={api.docLink}
                          target="_blank"
                          className="api-doc-link"
                        >
                          View Documentation{" "}
                          <i className="fa-solid fa-arrow-right"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/*===== CTA SECTION =====*/}
          <section className="api-cta sp1 bg2">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="cta-content heading2">
                    <h2>Ready to integrate APIs?</h2>
                    <p>
                      Get in touch with our teams for API related inquiry. We'll
                      help you choose the right APIs and assist with the
                      integration process.
                    </p>
                    <div className="btn-area mt-4 d-flex justify-content-center flex-wrap gap-3">
                      <a href="/contact-us" className="header-btn11">
                        Contact Sales{" "}
                        <i className="fa-solid fa-arrow-right"></i>
                      </a>
                      <a
                        href="https://developers.instantpanmitra.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="header-btn10"
                      >
                        Explore Docs <i className="fa-solid fa-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/*===== SUPPORT SECTION =====*/}
          <section className="api-support sp1">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="support-content heading2">
                    <h5>Developer Friendly</h5>
                    <h2>We're here to help you succeed</h2>
                    <p>
                      Our team of API specialists provides end-to-end support –
                      from onboarding to production go-live. We offer:
                    </p>
                    <ul className="support-list">
                      <li>
                        <i className="fa-solid fa-check-circle text-primary"></i>{" "}
                        Comprehensive API documentation with code samples
                      </li>
                      <li>
                        <i className="fa-solid fa-check-circle text-primary"></i>{" "}
                        24/7 technical support via WhatsApp & email
                      </li>
                      <li>
                        <i className="fa-solid fa-check-circle text-primary"></i>{" "}
                        Dedicated integration manager for enterprise clients
                      </li>
                      <li>
                        <i className="fa-solid fa-check-circle text-primary"></i>{" "}
                        Regular updates & new feature notifications
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="support-image text-center">
                    <img
                      src="/images/developer-friendly.jpg"
                      alt="Developer support"
                      className="img-fluid rounded-4 shadow"
                      onError={(e) => (e.target.style.display = "none")} // fallback if image missing
                    />
                    {/* Fallback icon if image not available */}
                    {/* <div
                      className="fallback-icon"
                      style={{ fontSize: "8rem", color: "#dee2e6" }}
                    >
                      <i className="fa-solid fa-headset"></i>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
      <Footer />

      {/* Embedded CSS */}
      <style>{`
        .api-solutions-page {
          overflow-x: hidden;
        }

        /* API Intro */
        .api-intro .intro-text {
          font-size: 1.1rem;
          color: #4b5563;
          max-width: 800px;
          margin: 1.5rem auto 0;
        }

        /* API Cards Grid */
        .api-grid {
          background-color: #f9fafc;
        }

        .api-card {
          background: #fff;
          border-radius: 20px;
          padding: 30px 25px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;
          height: 100%;
          display: flex;
          flex-direction: column;
          border-top: 4px solid transparent;
          position: relative;
          overflow: hidden;
        }

        .api-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        }

        .card-header {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-bottom: 20px;
        }

        .api-icon {
          font-size: 2rem;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #f3f4f6;
        }

        .api-card h3 {
          font-size: 1.4rem;
          font-weight: 600;
          margin: 0;
          color: #1e293b;
        }

        .api-description {
          color: #4b5563;
          line-height: 1.6;
          margin-bottom: 20px;
          flex-grow: 1;
        }

        .api-features {
          list-style: none;
          padding: 0;
          margin: 0 0 25px 0;
        }

        .api-features li {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 10px;
          color: #334155;
          font-size: 0.95rem;
        }

        .api-features li i {
          font-size: 1.1rem;
          width: 20px;
        }

        .card-footer {
          margin-top: auto;
        }

        .api-doc-link {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          color: #2563eb;
          font-weight: 600;
          text-decoration: none;
          transition: gap 0.3s ease;
        }

        .api-doc-link:hover {
          gap: 12px;
          color: #1d4ed8;
        }

        /* CTA Section */
        .api-cta {
          background-color: #f8fafc;
          border-radius: 40px 40px 0 0;
        }

        /* Support Section */
        .support-list {
          list-style: none;
          padding: 0;
          margin: 25px 0 0;
        }

        .support-list li {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 15px;
          font-size: 1.05rem;
          color: #1e293b;
        }

        .support-list i {
          font-size: 1.3rem;
          color: #10b981;
        }

        .fallback-icon {
          opacity: 0.3;
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .api-card {
            padding: 20px;
          }
          .card-header {
            flex-direction: column;
            text-align: center;
          }
          .api-icon {
            margin-bottom: 10px;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default ApiSolutions;
